import { Action } from "redux";

export namespace AppContextActions {
  export enum ActionTypes {
    SET_LANGUAGE = "appContext/SET_LANGUAGE"
  }

  export type Actions = ReadyAction;

  interface ReadyAction extends Action<ActionTypes.SET_LANGUAGE> {
    payload: {
      language: string;
    };
  }

  export const setLanguage = (language: string): ReadyAction => {
    return {
      type: ActionTypes.SET_LANGUAGE,
      payload: { language }
    };
  };
}
